import AppBar from "@material-ui/core/AppBar";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import { grey } from "@material-ui/core/colors";
import CssBaseline from "@material-ui/core/CssBaseline";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Popover from "@material-ui/core/Popover";
import { makeStyles } from "@material-ui/core";
import {
  FaTimes,
  FaSearch,
  FaExclamationTriangle,
  FaStar,
  FaRegStar,
} from "react-icons/fa";
import {
  createMuiTheme,
  MuiThemeProvider,
  useTheme,
  withStyles,
} from "@material-ui/core/styles";
import Switch from "@material-ui/core/Switch";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import DonutLarge from "@material-ui/icons/DonutLarge";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import ImportContactsIcon from "@material-ui/icons/ImportContacts";
import SwapVertIcon from "@material-ui/icons/SwapVert";
import clsx from "clsx";
import PropTypes from "prop-types";
import React, { useContext, useEffect, useState } from "react";
import { AiFillGift } from "react-icons/ai";
import { BiBitcoin } from "react-icons/bi";
import { CgArrowsExchangeAltV } from "react-icons/cg";
import { FaRupeeSign } from "react-icons/fa";
import { FiSun } from "react-icons/fi";
import { IoMdMoon } from "react-icons/io";
import { RiSafe2Fill, RiUserSettingsLine } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import fetcher from "./api/swr_fetcher";
import LogoDark from "./assets/img/mainLogoDark.svg";
import LogoWhite from "./assets/img/mainLogoLight.svg";
import CurrencyList from "./components/CurrencyList";
import HelpDropDown from "./components/HelpDropDown";
import MobileNavbarDrawer from "./components/MobileNavbarDrawer";
import NotificationDropDown from "./components/NotificationDropDown";
import SimpleFooter from "./components/SimpleFooter";
import EndCredits from "./components/StaticComp/EndCredits/EndCredits";
import { CoinContext } from "./contexts/CoinContext";
import {
  detectIfFreshchatHasLoaded,
  hideFreshchatInMobile,
} from "./services/freshchat";
import useResizer from "./services/useResizer";
import useWindowDimensions from "./services/useWindowDimensions";
import MenuIcon from "@material-ui/icons/Menu";
import { HiMenu } from "react-icons/hi";
import useScript from "./services/useScript";
import { SET_DARK_MODE } from "./redux/types";
import { BsFillLightningChargeFill } from "react-icons/bs";
import CurrencyPanel from "./components/CurrencyPanel";
import StarIcon from "@material-ui/icons/Star";
import TradeIcon from "./assets/navbarIcons/tradeIcon";
import VaultIcon from "./assets/navbarIcons/vaultIcon";
import AccountIcon from "./assets/navbarIcons/accountIcon";
import DownloadIcon from "./assets/navbarIcons/downloadIcon";
import NotificationsIcon from "./assets/navbarIcons/notificationsIcon";
import PbAppQRCode from "./assets/navbarIcons/pbQRCode.svg";
import PortfolioIcon from "./assets/navbarIcons/portfolioIcon";
import WalletIcon from "./assets/navbarIcons/walletIcon";
import Tooltip from "@material-ui/core/Tooltip";
import Marketsnew from "./assets/navbarIcons/marketsnew";
import VaultNew from "./assets/navbarIcons/vaultnew";
import TradeNew from "./assets/navbarIcons/tradenew";
import PortfolioNew from "./assets/navbarIcons/portfolionew";
import MenuNew from "./assets/navbarIcons/menuNew";
import Chat from "./assets/navbarIcons/chat";
const drawerWidth = 280;
const drawerHeight = 840;

// for app bar tabs
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
const CenteredTabs = withStyles({
  flexContainer: {
    justifyContent: "space-between",
    // alignItems: "center",
  },
})(Tabs);

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

// for drawer tabs
function TabPanelDrawer(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      hidden={value !== index}
      id={`simple-tabpaneldrawer-${index}`}
      aria-labelledby={`simple-tabdrawer-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

TabPanelDrawer.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yPropsDrawer(index) {
  return {
    id: `simple-tabdrawer-${index}`,
    "aria-controls": `simple-tabpaneldrawer-${index}`,
  };
}

export default function Layout(props) {
  const isMobile = useResizer();
  const classes = useStyles();
  const theme = useTheme();
  let history = useHistory();
  const dispatch = useDispatch();
  const { height, width } = useWindowDimensions();
  useScript("https://app.getbeamer.com/js/beamer-embed.js");

  useEffect(() => {
    fetcher("/v1/account")
      .then((data) => {
        if (data) {
          // window.Beamer?.destroy();
          window.beamer_config = {
            product_id: "byrdvtHp31966",
            button: false,
            ...(data.firstName && { user_firstname: data.firstName }),
            ...(data.lastName && { user_lastname: data.lastName }),
            user_email: data.email,
            user_id: data.email,
          };
          window.Beamer?.init();

          // const script = document.createElement("script");
          // script.id = "beamer";
          // script.src = "https://app.getbeamer.com/js/beamer-embed.js";
          // script.async = true;
          // script.defer = "defer";

          // document.body.appendChild(script);
        }
      })
      .catch((e) => {
        window.Beamer?.destroy(true);
        window.beamer_config = {
          product_id: "byrdvtHp31966",
          button: false,
        };
        window.Beamer?.init();
      });
    return () => {
      window.Beamer?.destroy(true);
    };
  }, []);

  // const [isMobile, setIsMobile] = useState(useMediaQuery(theme.breakpoints.down('sm')))
  var tabNumber = {
    "/trade/:coin": 0,
    "/portfolio": 2,
    "/wallet/inr": 3,
    "/wallet/crypto": 3,
    "/wallet/inr/deposit": 3,
    "/wallet/inr/withdraw": 3,
    "/wallet/crypto/deposit": 3,
    "/wallet/crypto/withdraw": 3,
    "/vault": 1,
  };
  // var tabNumberMobile = {'/currency': 0,'/trade/:coin': 1, '/orderhistory': 2, '/wallet/crypto': 3, '/wallet/inr': 4, '/inr/deposit': 4, '/inr/withdraw': 4}

  // openDrawer gets a new value everytime, so that useEffect is run again
  const { openDrawer, updateKycData } = useContext(CoinContext);
  const [isKycLoaded, setIsKycLoaded] = useState(false);
  // this is to close the drawer when screen is in mobile mode, since drawer should not be visible in mobile view
  const [open, setOpen] = useState(true);

  // value is for the appbar tabs in desktopview
  const [value, setValue] = useState(0);
  // valueMobile is for the bottom navbar tabs in mobile view
  const [valueMobile, setValueMobile] = useState(0);
  const valueMobileFromStore = useSelector((state) => state.trading.MOBILE_TAB);

  // valueDrawer is for the drawer tabs
  const [valueDrawer, setValueDrawer] = useState(0);

  const [anchorSett, setAnchorSett] = useState(null);
  const [anchorWallet, setAnchorWallet] = useState(null);

  // settingsView is used to hide and unhide the button for drawer open/close
  // it also controls the width of appbar
  const [settingsView, setSettingsView] = useState(false);
  const unreadCount = useSelector(
    (state) => state.trading.FRESHCHAT_UNREAD_COUNT
  );
  const mobileApp = useSelector((state) => state.trading.IS_USING_MOBILE_APP);
  // to hide and show kyc banner
  const [hideBanner, setHideBanner] = useState(false);

  // kycVerified or not and user name
  const [kycDetails, setKycDetails] = useState({
    verified: true,
    stepOneComplete: true,
    stepTwoComplete: true,
    stepThreeComplete: true,
    stepFourComplete: true,
  });
  // const [userName, setUserName] = useState(null);

  // swipeable settings drawer for mobile view
  const [swipeableOpen, setSwipeableOpen] = useState(false);

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setSwipeableOpen(open);
  };

  const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent);
  const token = useSelector((state) => state.trading.TOKEN);
  const loginId = useSelector((state) => state.trading.LOGIN_ID);
  useEffect(() => {
    const deviceToken = localStorage.getItem("device_token");

    if (deviceToken && deviceToken != "NA" && token) {
      sendDeviceToken(deviceToken);
    }

    if (
      window.location.pathname.slice(0, 6) === "/trade" ||
      window.location.pathname === "/"
    ) {
      setValue(0);
      // setValueMobile(1)
    } else {
      if (tabNumber[window.location.pathname]) {
        setValue(tabNumber[window.location.pathname]);
      } else {
        setValue(false);
      }
      // setValueMobile(tabNumberMobile[window.location.pathname])
    }

    // to control drawer open close based on which page and mobile view
    if (
      window.location.pathname === "/accsettings" ||
      window.location.pathname === "/onboarding" ||
      width <= 950
    ) {
      setOpen(false);
      setSettingsView(true);
    } else {
      setOpen(true);
      setSettingsView(false);
    }

    // to hide and show kyc banner
    if (
      window.location.pathname === "/accsettings" ||
      window.location.pathname === "/onboarding"
    ) {
      setHideBanner(true);
    } else {
      setHideBanner(false);
    }

    history.listen((location) => {
      if (
        location.pathname.slice(0, 6) === "/trade" ||
        location.pathname === "/"
      ) {
        setValue(0);
        // setValueMobile(1)
      } else {
        if (tabNumber[location.pathname]) {
          setValue(tabNumber[location.pathname]);
        } else {
          setValue(false);
        }
        // setValueMobile(tabNumberMobile[window.location.pathname])
      }

      // console.log(location.pathname);

      // to control drawer open close based on which page and mobile view
      if (
        location.pathname === "/accsettings" ||
        location.pathname === "/onboarding" ||
        width <= 950
      ) {
        setOpen(false);
        setSettingsView(true);
      } else {
        setOpen(true);
        setSettingsView(false);
      }

      // to hide and show kyc banner
      if (
        location.pathname === "/accsettings" ||
        location.pathname === "/onboarding"
      ) {
        setHideBanner(true);
      } else {
        setHideBanner(false);
      }
    });

    if (width <= 950) {
      setOpen(false);
      setSettingsView(true);
    }

    fetcher(`/v1/um/getKycDetails`)
      .then((data) => {
        setKycDetails(data);
        updateKycData(data);
        setIsKycLoaded(true);
        // console.log("Kyc details:", data);

        window.fcWidget.user.setFirstName(data.firstName);
        window.fcWidget.user.setLastName(data.lastName);
      })
      .catch((err) => {
        setKycDetails(false);
        if (err.status) {
          setIsKycLoaded(true);
        } else {
          setIsKycLoaded(false);
        }

        // console.error(err);
      });

    //moving the freshchat popup above the mobile banner
    hideFreshchatInMobile();
    fetchCoinConfig();
  }, []);

  const sendDeviceToken = (deviceToken) => {
    fetcher(`/v1/um/fcm`, {
      method: "POST",
      body: { deviceToken: deviceToken },
    });
  };

  const fetchCoinConfig = (e) => {
    fetcher(`/v1/coinConfig`).then((data) => {
      let temp = {};
      data.map((ele, idx) => {
        temp[ele.coinId] = ele;
      });
      dispatch({ type: "SET_COIN_ICONS", payload: temp });
    });
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeDrawer = (event, newValue) => {
    setValueDrawer(newValue);
  };

  const handleChangeMobile = (event, newValue) => {
    console.log(newValue, "VALUE");
    setValueMobile(newValue);
    dispatch({ type: "SET_MOBILE_TAB", payload: newValue });
  };

  const handleMobileDrawerOpen = () => {
    setSwipeableOpen(true);
  };
  useEffect(() => {
    if (window.location?.pathname?.includes("/trade")) {
      setValueMobile(2);
    } else if (window.location?.pathname?.includes("/portfolio")) {
      setValueMobile(3);
    } else if (window.location?.pathname?.includes("/vault")) {
      setValueMobile(1);
    } else {
      setValueMobile(4);
    }
  }, [window.location.pathname]);
  const handleMobileDrawerClose = () => {
    setSwipeableOpen(false);
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  //for handling the popover when clicked on user icon
  const handleClickSettings = (event) => {
    setAnchorSett(event.currentTarget);
  };

  const handleCloseSettings = () => {
    setAnchorSett(null);
  };

  const openSettings = Boolean(anchorSett);
  const id = openSettings ? "simple-popover" : undefined;

  //for handling the popover when clicked on wallet tab
  const handleClickWallet = (event) => {
    setAnchorWallet(event.currentTarget);
  };

  const handleCloseWallet = () => {
    setAnchorWallet(null);
  };

  const openWallet = Boolean(anchorWallet);
  const idWallet = openWallet ? "simple-popover-wallet" : undefined;

  // const [darkState, setDarkState] = useState(modeL.dark);
  const darkState = useSelector((state) => state.trading.DARK_MODE);

  const darkTheme = createMuiTheme({
    ...theme,
    overrides: {
      MuiTab: {
        root: {
          [theme.breakpoints.down("md")]: {
            padding: "0px",
          },
        },
      },
      MuiToolbar: {
        root: {
          [theme.breakpoints.down("md")]: {
            overflow: "hidden",
          },
        },
      },
    },
    palette: {
      type: darkState ? "dark" : "light",
      primary: {
        main: "#3AC4AB",
      },
      secondary: {
        main: "#ffffff",
      },
      background: {
        paper: darkState ? "#151828" : "white",
        default: darkState ? "#1a1f2b" : "#F7F7F7",
      },
    },
    typography: {
      useNextVariants: true,
      fontFamily: ['"Gordita"', "sans-serif"].join(","),
    },
  });

  const handleThemeChange = () => {
    // modeL.dark = !modeL.dark;

    dispatch({ type: SET_DARK_MODE, payload: !darkState });

    // setDarkState(modeL.dark);
  };

  // for Logout

  const [logoutDialog, setLogoutDialog] = useState(false);

  const handleLogoutDialogOpen = () => {
    setLogoutDialog(true);
  };

  const handleLogoutDialogClose = () => {
    setLogoutDialog(false);
  };

  function handleLogout() {
    // console.log("Logging out");
    dispatch({ type: "SET_TOKEN", payload: null });
    dispatch({ type: "SET_TOKEN_STATUS", payload: null });
    dispatch({ type: "SET_LOGIN_ID", payload: null });

    window.fcWidget.user.clear();
    history.push(`/login`);

    // window.location.reload();
  }

  const [notificationIconMouseEnter, setNotificationIconMouseEnter] =
    useState(false);
  const [downloadIconMouseEnter, setDownloadIconMouseEnter] = useState(false);
  const [accountIconMouseEnter, setAccountIconMouseEnter] = useState(false);

  const [downloadIconOpenTooltip, setDownloadIconOpenTooltip] = useState(false);
  console.log(valueMobileFromStore, "store");
  return (
    <MuiThemeProvider theme={darkTheme}>
      <CssBaseline />

      <div className={classes.root}>
        {/*This is visible only for screen sizes sm, xs*/}
        <Hidden mdUp>
          <AppBar
            // position="fixed"
            className={classes.mobileAppbar}
            style={{
              background: darkState ? "#141828" : "white",
              height: "auto",
            }} //height: kycDetails.status === "approved" ? "40px" : "100px" }}
          >
            <Toolbar
              disableGutters
              style={{ padding: "0px 8px", minHeight: "40px", height: "45px" }}
            >
              <div
                onClick={() => {
                  history.push(`/`);
                  setOpen(true);
                }}
              >
                {darkState ? (
                  <img
                    src={LogoWhite}
                    className={classes.mainLogo}
                    alt="PocketBits"
                  ></img>
                ) : (
                  <img
                    src={LogoDark}
                    className={classes.mainLogo}
                    alt="PocketBits"
                  ></img>
                )}
              </div>
              {/* <ScreenSize /> */}
              <div className={classes.grow} />
              {token ? (
                <>
                  <NotificationDropDown />

                  {/* {darkState ? (
                    <FiSun
                      onClick={handleThemeChange}
                      style={{
                        color: darkState ? "#A9A9A9" : "#FBAB20",
                        fontSize: "20px",
                      }}
                    />
                  ) : (
                    <IoMdMoon
                      onClick={handleThemeChange}
                      style={{
                        color: darkState ? "#3AC4AB" : "#A9A9A9",
                        fontSize: "20px",
                      }}
                    />
                  )} */}
                  {/* <HelpDropDown /> */}
                  <IconButton
                    className="p-1"
                    aria-describedby={id}
                    onClick={() => {
                      if (detectIfFreshchatHasLoaded()) {
                        document.querySelector(
                          "#fc_frame, #fc_frame.fc-widget-normal"
                        ).style.display = "block";
                        window.fcWidget.open();
                        window.fcWidget.show();
                      }
                    }}
                  >
                    <Chat />
                  </IconButton>
                  <IconButton
                    aria-describedby={id}
                    onClick={toggleDrawer("right", true)}
                  >
                    <AccountCircleIcon
                      fontSize="large"
                      style={{ color: darkState ? "white" : "black" }}
                    />
                  </IconButton>
                  {kycDetails.firstName && kycDetails.lastName ? (
                    <span
                      style={{
                        fontSize: "11px",
                        color: darkState ? "#ffffff" : "black",
                        fontWeight: "bold",
                      }}
                      className={classes.username}
                    >
                      {/* {`${kycDetails.firstName} ${kycDetails.lastName}`} */}
                    </span>
                  ) : null}
                </>
              ) : (
                <div className="flex items-center">
                  <Button
                    onClick={() => {
                      history.push(`/login`);
                    }}
                    variant="contained"
                    color="primary"
                    style={{
                      fontSize: "10px",
                      color: "white",
                      fontWeight: "bold",
                    }}
                    className="mr-3"
                  >
                    Signin
                  </Button>
                  <div
                    style={{ width: "44px", height: "44px" }}
                    className="flex items-center justify-center cursor-pointer"
                  >
                    <HiMenu
                      onClick={handleMobileDrawerOpen}
                      className="dark:text-gray-500 "
                      size={32}
                    ></HiMenu>
                  </div>
                </div>
              )}
            </Toolbar>
            <Divider />
            {token && isKycLoaded ? (
              kycDetails.verified === true ||
              kycDetails.status === "approved" ? null : hideBanner ? null : (
                <div
                  style={{
                    backgroundImage:
                      "linear-gradient(to right, #002d64 , #89aadc)",
                    padding: "10px 20px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <p
                      style={{
                        fontWeight: "bold",
                        color: "white",
                      }}
                    >
                      {kycDetails.stepOneComplete &&
                      kycDetails.stepTwoComplete &&
                      kycDetails.stepThreeComplete &&
                      kycDetails.stepFourComplete
                        ? `You are one step closer to Trading! Our KYC team shall review your request within 59mins.`
                        : kycDetails.status === "rejected"
                        ? "Your KYC details are rejected. Please try again."
                        : "Complete your KYC to unlock all features!"}
                    </p>
                    {kycDetails.stepOneComplete &&
                    kycDetails.stepTwoComplete &&
                    kycDetails.stepThreeComplete &&
                    kycDetails.stepFourComplete ? null : (
                      <Button
                        variant="contained"
                        style={{
                          marginLeft: "20px",
                          color: "#4A74A7",
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                        }}
                        onClick={() => {
                          setValue(false);
                          setValueMobile(false);
                          history.push(`/onboarding`);
                        }}
                      >
                        Get started
                      </Button>
                    )}
                  </div>
                </div>
              )
            ) : null}
          </AppBar>

          <div
            className={classes.content}
            style={{
              marginTop:
                token && !hideBanner
                  ? kycDetails.verified === true ||
                    kycDetails.status === "approved"
                    ? "60px"
                    : "113px"
                  : "60px",
            }}
          >
            <div>
              {/*<div className={classes.toolbar} />*/}
              {props.children}
            </div>
          </div>
        </Hidden>

        <AppBar
          position="fixed"
          className={clsx(classes.appBar, {
            [classes.appBarShift]: open,
          })}
          style={{
            background: darkState ? "#141828" : "white",
            height: "auto",
          }} //height: kycDetails.status === "approved" ? "45px" : "100px"}}////
        >
          <Divider />
          <Toolbar
            disableGutters
            className={classes.bar}
            style={{ height: !isMobile ? "45px" : "64px" }}
          >
            {/*This is visible only for screen sizes md, lg, xl*/}
            <Hidden smDown>
              {settingsView ? null : (
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  onClick={handleDrawerOpen}
                  edge="start"
                  className={clsx(classes.menuButton, {
                    [classes.hide]: open,
                  })}
                >
                  <MenuIcon style={{ color: darkState ? "white" : "black" }} />
                </IconButton>
              )}
              <div
                onClick={() => {
                  history.push(`/`);
                  setOpen(true);
                }}
              >
                {darkState ? (
                  <img
                    src={LogoWhite}
                    className={classes.mainLogo}
                    alt="PocketBits"
                  ></img>
                ) : (
                  <img
                    src={LogoDark}
                    className={classes.mainLogo}
                    alt="PocketBits"
                  ></img>
                )}
              </div>

              {Boolean(token) ? (
                <>
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    style={{ height: "45px", marginLeft: "20px" }} //64px
                  >
                    <Tab
                      label="Trade"
                      classes={{
                        wrapper: classes.iconLabelWrapper,
                      }}
                      style={{ minWidth: "10px", margin: "0px 5px" }}
                      icon={
                        <div className="mr-2 mb-0" style={{ height: "20px" }}>
                          <TradeIcon
                            fill={
                              value == 0 &&
                              window.location.pathname.slice(0, 6) === "/trade"
                                ? "#3AC4AB"
                                : "#B9BABF"
                            }
                          />
                        </div>
                      }
                      {...a11yProps(0)}
                      onClick={() => {
                        history.push(`/trade/BTC`);
                      }}
                    />
                    <Tab
                      label="Vault"
                      classes={{
                        wrapper: classes.iconLabelWrapper,
                      }}
                      style={{ minWidth: "10px", margin: "0px 5px" }}
                      onClick={() => {
                        history.push("/vault");
                      }}
                      icon={
                        <div className="mr-2 mb-0" style={{ height: "20px" }}>
                          <VaultIcon
                            fill={value == 1 ? "#3AC4AB" : "#B9BABF"}
                          />
                        </div>
                      }
                    />
                    <Tab
                      label="Portfolio"
                      classes={{
                        wrapper: classes.iconLabelWrapper,
                      }}
                      style={{ minWidth: "10px", margin: "0px 5px" }}
                      icon={
                        <div className="mr-2 mb-0" style={{ height: "20px" }}>
                          <PortfolioIcon
                            fill={value == 2 ? "#3AC4AB" : "#B9BABF"}
                          />
                        </div>
                      }
                      {...a11yProps(1)}
                      onClick={() => {
                        history.push(`/portfolio`);
                      }}
                    />
                    <Tab
                      label="Wallet"
                      classes={{
                        wrapper: classes.iconLabelWrapper,
                      }}
                      style={{ minWidth: "10px", margin: "0px 5px" }}
                      icon={
                        <div className="mr-2 mb-0" style={{ height: "20px" }}>
                          <WalletIcon
                            fill={value == 3 ? "#3AC4AB" : "#B9BABF"}
                          />
                        </div>
                      }
                      {...a11yProps(2)}
                      onClick={handleClickWallet}
                    />
                  </Tabs>
                  <div className={classes.grow} />
                  <div className="flex justify-center items-center">
                    <Button
                      variant="contained"
                      color="white"
                      size="small"
                      className={classes.earnForLifetimeButton}
                      style={{
                        fontWeight: "bold",
                        margin: "0px 5px",
                        textTransform: "none",
                      }}
                      onClick={() => history.push(`/invite`)}
                    >
                      Rewards
                    </Button>
                    <div className="mx-2">
                      <NotificationDropDown />
                    </div>

                    <Tooltip
                      open={downloadIconOpenTooltip}
                      onOpen={() => setDownloadIconOpenTooltip(true)}
                      onClose={() => setDownloadIconOpenTooltip(false)}
                      classes={{
                        tooltip: classes.customTooltip,
                      }}
                      title={
                        <div className="p-1 flex flex-col justify-center items-center">
                          <p className="mb-2 text-center text-sm">
                            Scan to download <br /> Android App
                          </p>
                          <img src={PbAppQRCode} />
                        </div>
                      }
                      placement="bottom-end"
                    >
                      <div
                        className="mx-2 cursor-pointer"
                        style={{ height: "24px" }}
                        onMouseEnter={() => setDownloadIconMouseEnter(true)}
                        onMouseLeave={() => setDownloadIconMouseEnter(false)}
                      >
                        <DownloadIcon
                          fill={downloadIconMouseEnter ? "#3AC3AB" : "#B9BABF"}
                        />
                      </div>
                    </Tooltip>

                    {/* <FiSun
                    style={{
                      color: darkState ? "#A9A9A9" : "#FBAB20",
                      fontSize: "20px",
                    }}
                  />
                  <Switch
                    onChange={handleThemeChange}
                    checked={darkState}
                    color="primary"
                  />
                  <IoMdMoon
                    style={{
                      color: darkState ? "#3AC4AB" : "#A9A9A9",
                      fontSize: "20px",
                      marginRight: "10px",
                    }}
                  />

                  <HelpDropDown /> */}

                    <div
                      onClick={handleClickSettings}
                      className="flex items-center mx-2 cursor-pointer"
                    >
                      {/* <IconButton aria-describedby={id}> */}
                      <AccountIcon
                        fill={anchorSett != null ? "#3AC3AB" : "#B9BABF"}
                        // fontSize="large"
                        // style={{ color: darkState ? "white" : "black" }}
                      />
                      {/* </IconButton> */}
                      {kycDetails.firstName && kycDetails.lastName ? (
                        <span
                          style={{
                            // marginLeft: "5px",
                            color: darkState ? "#B9BABF" : "black",
                            fontWeight: "bold",
                            whiteSpace: "nowrap",
                            marginLeft: "0.5rem",
                          }}
                          className={classes.username}
                        >
                          {`${kycDetails.firstName}`}
                        </span>
                      ) : null}
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    style={{ height: "45px", marginLeft: "20px" }} //64px
                  >
                    <Tab
                      label="Trade"
                      classes={{
                        wrapper: classes.iconLabelWrapper,
                      }}
                      style={{ minWidth: "10px", margin: "0px 5px" }}
                      icon={
                        <div className="mr-2 mb-0" style={{ height: "20px" }}>
                          <TradeIcon
                            fill={
                              value == 0 &&
                              window.location.pathname.slice(0, 6) === "/trade"
                                ? "#3AC4AB"
                                : "#B9BABF"
                            }
                          />
                        </div>
                      }
                      onClick={() => {
                        history.push("/trade/BTC");
                      }}
                      {...a11yProps(0)}
                    />{" "}
                    <Tab
                      label="Vault"
                      classes={{
                        wrapper: classes.iconLabelWrapper,
                      }}
                      onClick={() => {
                        history.push("/vault");
                      }}
                      style={{
                        display: "inline-block",
                        minWidth: "10px",
                        margin: "0px 5px",
                      }}
                      icon={
                        <div className="mr-2 mb-0" style={{ height: "20px" }}>
                          <VaultIcon
                            fill={value == 1 ? "#3AC4AB" : "#B9BABF"}
                          />
                        </div>
                      }
                    />
                  </Tabs>
                  <div className={classes.grow} />
                  <Button
                    variant="contained"
                    color="white"
                    size="small"
                    className={classes.earnForLifetimeButton}
                    style={{
                      fontWeight: "bold",
                      margin: "0px 5px",
                      textTransform: "none",
                    }}
                    onClick={() => history.push(`/invite`)}
                  >
                    Rewards
                  </Button>
                  {/* <div className="mx-2 cursor-pointer">
                    <NotificationsIcon fill={'#B9BABF'}/>
                  </div> */}
                  <Tooltip
                    open={downloadIconOpenTooltip}
                    onOpen={() => setDownloadIconOpenTooltip(true)}
                    onClose={() => setDownloadIconOpenTooltip(false)}
                    title={
                      <div className="flex flex-col justify-center items-center">
                        <p className="mb-2 text-center text-sm">
                          Scan to download <br /> Android App
                        </p>
                        <img src={PbAppQRCode} />
                      </div>
                    }
                    placement="bottom-end"
                    classes={{
                      tooltip: classes.customTooltip,
                    }}
                  >
                    <div
                      className="mx-2 cursor-pointer"
                      onMouseEnter={() => setDownloadIconMouseEnter(true)}
                      onMouseLeave={() => setDownloadIconMouseEnter(false)}
                    >
                      <DownloadIcon
                        fill={downloadIconMouseEnter ? "#3AC3AB" : "#B9BABF"}
                      />
                    </div>
                  </Tooltip>
                  {/* <div className="mx-2 cursor-pointer">
                    <AccountIcon fill={'#B9BABF'}/>
                  </div> */}
                  {/* <FiSun
                    style={{
                      color: darkState ? "#A9A9A9" : "#FBAB20",
                      fontSize: "20px",
                    }}
                  />
                  <Switch
                    onChange={handleThemeChange}
                    checked={darkState}
                    color="primary"
                  />
                  <IoMdMoon
                    style={{
                      color: darkState ? "#3AC4AB" : "#A9A9A9",
                      fontSize: "20px",
                      marginRight: "10px",
                    }}
                  /> */}
                </>
              )}
            </Hidden>

            {/*This is visible only for screen sizes sm, xs*/}
            <Hidden mdUp className="w-full">
              <CenteredTabs
                value={valueMobile}
                onChange={handleChangeMobile}
                indicatorColor="primary"
                textColor="primary"
                className="w-full"
                // fullWidth={true}
                // centered
                style={{ height: "70px !important" }}
              >
                <Tab
                  label="Markets"
                  style={{ fontSize: "8px" }}
                  icon={
                    <Marketsnew
                      fill={
                        window.location.pathname?.includes("/currency")
                          ? "#3AC4AB"
                          : "#FFFFFF"
                      }
                    />
                  }
                  {...a11yProps(0)}
                  onClick={() => {
                    history.push(`/currency`);
                  }}
                />
                <Tab
                  label="Vault"
                  style={{ fontSize: "8px" }}
                  icon={
                    <VaultNew
                      fill={
                        window.location.pathname?.includes("/vault")
                          ? "#3AC4AB"
                          : "#FFFFFF"
                      }
                    />
                  }
                  {...a11yProps(1)}
                  onClick={() => {
                    history.push(`/vault`);
                  }}
                />
                <Tab
                  style={{ fontSize: "8px" }}
                  label="Trade"
                  icon={
                    <TradeNew
                      fill={
                        window.location.pathname?.includes("/trade")
                          ? "#3AC4AB"
                          : "#FFFFFF"
                      }
                    />
                  }
                  {...a11yProps(2)}
                  onClick={() => {
                    history.push(`/trade/BTC`);
                  }}
                ></Tab>
                <Tab
                  label="Portfolio"
                  style={{
                    fontSize: "8px",
                  }}
                  icon={
                    <PortfolioNew
                      fill={
                        window.location.pathname?.includes("/portfolio")
                          ? "#3AC4AB"
                          : "#FFFFFF"
                      }
                    />
                  }
                  {...a11yProps(3)}
                  onClick={() => {
                    if (token) {
                      history.push(`/portfolio`);
                    } else {
                      history.push(`/login`);
                    }
                  }}
                />
                <Tab
                  label="Menu"
                  style={{ fontSize: "8px" }}
                  className="font-bold text-white overflow-hidden"
                  value={valueMobile}
                  icon={
                    <>
                      <MenuNew />
                    </>
                  }
                  {...a11yProps(4)}
                  onClick={() => {
                    handleMobileDrawerOpen();
                  }}
                ></Tab>{" "}
                {/* <div className="bg-opacity-50 dark:text-white text-gray-200 text-[8px] flex flex-col items-center justify-center">
                  <AccountBalanceWalletIcon style={{ fontSize: 30 }} />
                  CHAT WITH US
                </div> */}
              </CenteredTabs>
            </Hidden>
          </Toolbar>

          {/* for desktop only */}
          <Hidden smDown>
            {token && isKycLoaded ? (
              kycDetails.verified === true ||
              kycDetails.status === "approved" ? null : hideBanner ? null : (
                <div
                  style={{
                    backgroundImage:
                      "linear-gradient(to right, #002d64 , #89aadc)",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    position: "relative",
                    top: "5px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <p
                      style={{
                        fontWeight: "bold",
                        color: "white",
                        fontSize: "17px",
                      }}
                    >
                      {kycDetails.stepOneComplete &&
                      kycDetails.stepTwoComplete &&
                      kycDetails.stepThreeComplete &&
                      kycDetails.stepFourComplete
                        ? `You are one step closer to Trading! Our KYC team shall review your request within 59mins.`
                        : kycDetails.status === "rejected"
                        ? "Your KYC details are rejected. Please try again."
                        : "Complete your KYC to unlock all features!"}
                    </p>
                    {kycDetails.stepOneComplete &&
                    kycDetails.stepTwoComplete &&
                    kycDetails.stepThreeComplete &&
                    kycDetails.stepFourComplete ? null : (
                      <Button
                        variant="contained"
                        style={{
                          marginLeft: "20px",
                          color: "#4A74A7",
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                        }}
                        onClick={() => {
                          setValue(false);
                          setValueMobile(false);
                          history.push(`/accsettings`);
                        }}
                      >
                        Get started
                      </Button>
                    )}
                  </div>
                </div>
              )
            ) : null}
          </Hidden>
        </AppBar>

        {/* User settings: popover for desktop and swipeable drawer for mobile */}
        <Hidden smDown>
          <Popover
            id={id}
            open={openSettings}
            anchorEl={anchorSett}
            onClose={handleCloseSettings}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
          >
            <Box
              className={classes.typography}
              style={{
                background: darkState ? "#151828" : "white",
                minWidth: "280px",
              }}
            >
              <List>
                <Hidden mdUp>
                  {/* <ListItem
                    button
                    onClick={() => {
                      history.push(`/`);
                      setValue(false);
                      setValueMobile(false);
                      handleCloseSettings();
                    }}
                  >
                    <ListItemIcon>
                      <Home></Home>
                    </ListItemIcon>
                    <ListItemText primary="Home"></ListItemText>
                  </ListItem> */}
                  <ListItem
                    button
                    onClick={() => {
                      history.push(`/portfolio`);
                      setValue(false);
                      setValueMobile(false);
                      handleCloseSettings();
                    }}
                  >
                    <ListItemIcon>
                      <DonutLarge></DonutLarge>
                    </ListItemIcon>
                    <ListItemText primary="My Portfolio"></ListItemText>
                  </ListItem>
                  <ListItem
                    button
                    onClick={() => {
                      history.push(`/onboarding`);
                      setValue(false);
                      setValueMobile(false);
                      handleCloseSettings();
                    }}
                  >
                    <ListItemIcon> </ListItemIcon>
                    <ListItemText primary="Profile"></ListItemText>
                  </ListItem>
                </Hidden>

                <Hidden smDown>
                  {/* <ListItem
                    button
                    onClick={() => {
                      history.push(`/`);
                      setValue(false);
                      setValueMobile(false);
                      handleCloseSettings();
                    }}
                  >
                    <ListItemIcon>
                      <Home
                        style={{
                          fontSize: "23px",
                          color:
                            theme.palette.type === "dark" ? "white" : "#707070",
                        }}
                      ></Home>
                    </ListItemIcon>
                    <ListItemText primary="Home"></ListItemText>
                  </ListItem> */}
                  <ListItem
                    button
                    onClick={() => {
                      history.push(`/accsettings`);
                      setValue(false);
                      setValueMobile(false);
                      handleCloseSettings();
                    }}
                  >
                    <ListItemIcon>
                      <RiUserSettingsLine
                        style={{
                          fontSize: "23px",
                          color: darkState ? "white" : "#707070",
                        }}
                      />
                    </ListItemIcon>
                    <ListItemText primary="Account Settings"></ListItemText>
                  </ListItem>
                </Hidden>

                <ListItem
                  button
                  onClick={() => {
                    history.push(`/transactions`);
                    setValue(false);
                    setValueMobile(false);
                    handleCloseSettings();
                  }}
                >
                  <ListItemIcon>
                    <CgArrowsExchangeAltV
                      style={{
                        fontSize: "30px",
                        color: darkState ? "white" : "#707070",
                      }}
                    />
                  </ListItemIcon>
                  <ListItemText primary="Transactions"></ListItemText>
                </ListItem>
                <ListItem
                  button
                  onClick={() => {
                    history.push(`/invite`);
                    setValue(false);
                    setValueMobile(false);
                    handleCloseSettings();
                  }}
                >
                  <ListItemIcon>
                    <AiFillGift
                      style={{
                        fontSize: "24px",
                        color: darkState ? "white" : "#707070",
                      }}
                    />
                  </ListItemIcon>
                  <ListItemText primary="Refer & Earn"></ListItemText>
                </ListItem>
                <ListItem
                  button
                  onClick={() => {
                    handleLogoutDialogOpen();
                    handleCloseSettings();
                  }}
                >
                  <ListItemIcon>
                    <ExitToAppIcon />
                  </ListItemIcon>
                  <ListItemText primary="Logout" />
                </ListItem>
              </List>
            </Box>
          </Popover>
        </Hidden>

        <Hidden mdUp>
          <MobileNavbarDrawer
            open={swipeableOpen}
            handleDrawerOpen={handleMobileDrawerOpen}
            handleDrawerClose={handleMobileDrawerClose}
          ></MobileNavbarDrawer>
        </Hidden>

        {/* User wallet popover */}
        <Popover
          id={idWallet}
          open={openWallet}
          anchorEl={anchorWallet}
          onClose={handleCloseWallet}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <Box
            className={classes.typography}
            style={{
              background: darkState ? "#151828" : "white",
              minWidth: "280px",
            }}
          >
            <List disablePadding>
              <ListItem
                button
                onClick={() => {
                  history.push(`/wallet/crypto`);
                  handleCloseWallet();
                }}
              >
                <ListItemIcon>
                  <BiBitcoin style={{ fontSize: 20 }} />
                </ListItemIcon>
                <ListItemText primary="Crypto Wallet"></ListItemText>
              </ListItem>
              <ListItem
                button
                onClick={() => {
                  history.push(`/wallet/inr`);
                  handleCloseWallet();
                }}
              >
                <ListItemIcon>
                  <FaRupeeSign style={{ fontSize: 20 }} />
                </ListItemIcon>
                <ListItemText primary="INR Wallet"></ListItemText>
              </ListItem>
            </List>
          </Box>
        </Popover>

        {/*This is visible only for screen sizes md, lg, xl*/}
        <Hidden smDown>
          {settingsView ? null : (
            <Drawer
              variant="permanent"
              className={clsx(classes.drawer, {
                [classes.drawerOpen]: open,
                [classes.drawerClose]: !open,
              })}
              classes={{
                paper: clsx(classes.drawer, {
                  [classes.drawerOpen]: open,
                  [classes.drawerClose]: !open,
                }),
              }}
              style={{ backgroundColor: "#141828" }}
            >
              <div>
                <Tabs
                  value={valueDrawer}
                  onChange={handleChangeDrawer}
                  indicatorColor="primary"
                  textColor="primary"
                  classes={{
                    root: classes.rootTabParent,
                  }}
                >
                  {" "}
                  <Tab
                    label="Markets"
                    className="capitalize "
                    classes={{ root: classes.rootTab }}
                    {...a11yPropsDrawer(1)}
                  />
                  <Tab
                    label="Innovation Zone"
                    icon={
                      <BsFillLightningChargeFill className="mr-1 text-[14px] " />
                    }
                    className="capitalize"
                    {...a11yPropsDrawer(0)}
                    classes={{
                      root: classes.rootTab,
                      wrapper: classes.wrapperTab,
                      labelIcon: classes.labelIconTab,
                    }}
                  />{" "}
                  <Tab
                    icon={<StarIcon className=" " size="18px" />}
                    className="uppercase"
                    classes={{ root: classes.rootTabFav }}
                    {...a11yPropsDrawer(0)}
                  />
                </Tabs>
                {/* <IconButton onClick={handleDrawerClose}>
                      {theme.direction === "rtl" ? (
                        <ChevronRightIcon />
                      ) : (
                        <ChevronLeftIcon />
                      )}
                    </IconButton> */}
              </div>
              <Divider className="mb-2" />
              <TabPanelDrawer value={valueDrawer} index={0}>
                <CurrencyPanel tab="MARKETS" />
              </TabPanelDrawer>
              <TabPanelDrawer value={valueDrawer} index={1}>
                <CurrencyPanel tab="INNOVATION" />
              </TabPanelDrawer>{" "}
              <TabPanelDrawer value={valueDrawer} index={2}>
                <CurrencyPanel tab="FAV" />
              </TabPanelDrawer>
            </Drawer>
          )}
        </Hidden>

        {/*This is visible only for screen sizes md, lg, xl*/}
        <Hidden smDown>
          <div
            className={classes.content}
            style={{
              marginTop:
                token && !hideBanner
                  ? kycDetails.verified === true ||
                    kycDetails.status === "approved"
                    ? "0px"
                    : "58px"
                  : "0px",
            }}
          >
            <div className={classes.toolbar} />
            {props.children}
          </div>
        </Hidden>
      </div>
      {!mobileApp && (
        <>
          <div
            className={clsx(classes.footer, {
              [classes.footerDrawer]: open,
            })}
          >
            {/* Please keep the SimpleFooter and EndCredits, do not replace it with FooterWithContent */}
            <SimpleFooter />
            {/* <FooterWithContent /> */}
            <EndCredits />
          </div>
        </>
      )}

      <Dialog
        open={logoutDialog}
        onClose={handleLogoutDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Are you sure you want to logout?
        </DialogTitle>
        <DialogActions style={{ paddingBottom: "20px", paddingRight: "15px" }}>
          <Button
            onClick={handleLogoutDialogClose}
            color="primary"
            variant="outlined"
            style={{ fontWeight: "bold" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleLogout}
            color="primary"
            variant="contained"
            autoFocus
            style={{ fontWeight: "bold", color: "white" }}
          >
            Logout
          </Button>
        </DialogActions>
      </Dialog>
    </MuiThemeProvider>
  );
}

const useStyles = makeStyles((darkTheme, isMobile) => ({
  rootTabParent: {
    minHeight: "45px",
    maxHeight: "45px",
    width: "100%",
    "& .Mui-selected": {
      fontWeight: "bolder",
      letterSpacing: "0px",
    },
  },
  rootTab: {
    fontSize: "13px",
    letterSpacing: "0.5px",
    padding: "0px 10px",
    height: "40px",
    // width: "10px",
    display: "flex",
    // fontWeight: "bold",
    alignItems: "center",
    minWidth: "calc((100% / 3) - 15px)",
    whiteSpace: "nowrap", // a number of your choice
  },
  rootTabFav: {
    padding: "0px 10px",
    height: "40px",
    alignItems: "center",
    minWidth: 42,
  },
  wrapperTab: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "4px",
  },
  labelIconTab: { minHeight: "45px" },
  root: {
    display: "flex",
  },
  listItemRoot: { paddingBottom: "0px" },
  buttonRoot: { background: grey[800] },
  listRoot: { marginTop: "100px" },
  paper: {
    background:
      darkTheme.palette.type == "dark"
        ? "rgba(0, 0, 0, 0.1)"
        : "radial-gradient(98.09% 98.09% at 31.51% 23.05%, rgba(255, 255, 255, 0.5)  100%, rgba(255, 255, 255, 0.5) 100%)",
    // backdropFilter: "blur(20px)",
    // width: "80%",

    backdropFilter: "blur(15px)",
    WebkitBackdropFilter: "blur(15px)",

    width: "80%",
  },
  grow: {
    flexGrow: 1,
  },
  sectionDesktop: {
    display: "none",
    [darkTheme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  appBar: {
    zIndex: darkTheme.zIndex.drawer + 1,
    transition: darkTheme.transitions.create(["width", "margin"], {
      easing: darkTheme.transitions.easing.sharp,
      duration: darkTheme.transitions.duration.leavingScreen,
    }),
    // background: '#141828',
    boxShadow: "none",
    height: !isMobile ? "45px" : "64px", //"45px",//64px
    [darkTheme.breakpoints.down("sm")]: {
      top: "auto",
      bottom: 0,
    },
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: darkTheme.transitions.create(["width", "margin"], {
      easing: darkTheme.transitions.easing.sharp,
      duration: darkTheme.transitions.duration.enteringScreen,
    }),
    // background: '#141828',
    boxShadow: "none",
  },
  menuButton: {
    marginRight: 28,
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    height: "calc(100vh)",
    overflow: "hidden",
    flexShrink: 0,
    whiteSpace: "nowrap",
    // background: '#141828'
    // borderRight: "1px solid #eee",
  },
  drawerOpen: {
    width: drawerWidth,
    transition: darkTheme.transitions.create("width", {
      easing: darkTheme.transitions.easing.sharp,
      duration: darkTheme.transitions.duration.enteringScreen,
    }),
    // background: '#141828'
  },
  drawerClose: {
    transition: darkTheme.transitions.create("width", {
      easing: darkTheme.transitions.easing.sharp,
      duration: darkTheme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    // width: darkTheme.spacing(7) + 1,
    [darkTheme.breakpoints.up("md")]: {
      width: darkTheme.spacing(6) + 16,
    },
    // background: '#141828'
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    // padding: darkTheme.spacing(0, 1),
    // necessary for content to be below app bar
    ...darkTheme.mixins.toolbar,
    maxWidth: drawerWidth,
    padding: "0px 8px",
    // backgroundColor: '#202333'
  },
  content: {
    width: "100vw",
    flexGrow: 1,
    // background: '#090D1C',
    // minHeight: "100vh",
    padding: darkTheme.spacing(3),
    [darkTheme.breakpoints.down("sm")]: {
      // marginTop: "60px",
      marginBottom: "60px",
      padding: darkTheme.spacing(2),

      margin: "0px",
    },
    [darkTheme.breakpoints.only("md")]: {
      minWidth: "1200px",
    },
  },
  footer: {
    [darkTheme.breakpoints.only("xs")]: {
      // minWidth: "500px",
    },
  },
  footerDrawer: {
    [darkTheme.breakpoints.up("md")]: {
      marginLeft: drawerWidth,
    },
  },
  bar: {
    margin: "0px 20px",
    [darkTheme.breakpoints.down("md")]: {
      margin: "0px",
    },
    minHeight: "40px !important",
    height: (isMobile) => (!isMobile ? "45px" : "63px"),
  },
  labelContainer: {
    width: "auto",
    padding: 0,
  },
  iconLabelWrapper: {
    flexDirection: "row",
    fontWeight: "bold",
    paddingBottom: "13px",
    marginBottom: "13px",
    textTransform: "none",
  },
  username: {
    "&:hover": {
      cursor: "pointer",
    },
    fontSize: "14px",
    whiteSpace: "no-wrap",
  },
  "@global": {
    "*::-webkit-scrollbar": {
      // width: "8px",
      width: "0px",
      [darkTheme.breakpoints.down("xs")]: {
        width: "0px",
      },
    },
    "*::-webkit-scrollbar-track": {
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.1)",
      backgroundColor: "transparent",
    },
    "*::-webkit-scrollbar-thumb": {
      // backgroundColor: (darkTheme.palette.type === 'dark') ? '#2D2F3E' : null,
      backgroundColor: "rgba(0, 0, 0, 0.2)",
      // backgroundColor: 'rgb(161, 221, 205)',
      // opacity: 0.5,
      borderRadius: "10px",
    },
  },
  mobileAppbar: {
    boxShadow: "none",
    // maxHeight: "56px",
    display: "flex",
    justifyContent: "center",
    minHeight: "40px",
    height: "50px",
    // [darkTheme.breakpoints.down('xs')]: {
    //   top: 0,
    //   bottom: 'auto'
    // }
  },
  mainLogo: {
    "&:hover": {
      cursor: "pointer",
    },

    width: "100%",
    minWidth: "150px",
    maxWidth: "150px", //160px
  },
  earnForLifetimeButton: {
    margin: "0 0.5rem",
    color: "white",
    backgroundColor: "#3AC4AB",
    "&:hover": {
      background: "#3AC4AB",
    },
  },
  tabsRoot: {
    maxHeight: "45px",
  },
  customTooltip: {
    backgroundColor: "#141828",
  },
}));
